import { NgModule } from '@angular/core';
import { LibSharedCommonModule } from '@solvace/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { SvcFilledBtnComponent } from './svc-filled-btn.component';

@NgModule({
  declarations: [
    SvcFilledBtnComponent
  ],
  imports: [
    LibSharedCommonModule,
    MatProgressSpinnerModule
  ],
  exports: [
    SvcFilledBtnComponent
  ]
})
export class SvcFilledBtnModule { }
